export default "__VITE_PUBLIC_ASSET__de923639__"